import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFamily, getMyFamilies } from "../../lib/api-family";
import type { Family } from "../../types/family";
import { EmptyFamilyState } from "../dashboard/EmptyFamilyState";
import { InviteCard } from "./InviteCard";
import { FamilyMembersList } from "./FamilyMembersList";

type State =
  | { status: "loading" }
  | { status: "empty" }
  | { status: "error" }
  | { status: "loaded"; family: Family };

export function FamilyOverview() {
  const [state, setState] = useState<State>({ status: "loading" });
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setState({ status: "loading" });
    try {
      const families = await getMyFamilies();
      const activeFamily = families[0];
      if (!activeFamily) {
        setState({ status: "empty" });
        return;
      }
      setState({ status: "loaded", family: await getFamily(activeFamily.id) });
    } catch {
      setState({ status: "error" });
    }
  }, []);

  useEffect(() => { void load(); }, [load]);

  if (state.status === "loading") {
    return <div className="flex flex-1 items-center justify-center" aria-label="Загрузка семьи"><div className="h-9 w-9 animate-spin rounded-full border-[3px] border-[#FF7A00] border-t-transparent" /></div>;
  }
  if (state.status === "empty") return <EmptyFamilyState />;
  if (state.status === "error") {
    return <div className="flex flex-1 flex-col items-center justify-center px-6 text-center"><h2 className="text-2xl font-extrabold text-[#171714]">Не удалось загрузить семью</h2><p className="mt-2 text-sm text-[#77776F]">Проверьте подключение и попробуйте снова.</p><button type="button" onClick={() => void load()} className="mt-6 rounded-full bg-[#171714] px-7 py-3 text-sm font-semibold text-white">Повторить</button></div>;
  }

  return (
    <div className="min-h-screen bg-[#F8F7F2] md:min-h-full lg:px-10 lg:py-6 xl:px-14">
      <header className="px-6 pt-8 lg:px-0"><p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#FF7A00]">Семейное пространство</p><h1 className="mt-1 text-[32px] font-extrabold tracking-[-0.05em] text-[#171714] lg:text-[46px]">{state.family.name}</h1></header>
      <InviteCard family={state.family} isAdmin={state.family.role === "admin"} onInviteCodeRotated={(family) => setState({ status: "loaded", family })} />
      <FamilyMembersList
        familyId={state.family.id}
        currentRole={state.family.role}
        onLeft={() => navigate("/", { replace: true })}
      />
    </div>
  );
}
